export const decodeTemplate = (template, data) => {

    switch (template) {

        case 'GENERAL':
            return `${data.message}`;
        case 'CUSTOMER_REGISTERED':
            return `A customer "${data.name}" is registered`;
        case 'BUSINESS_REGISTERED':
            return `Business "${data.name}" is registered`;
        case 'APPOINTMENT_BOOKED':
            return `Appointment booked for business "${data.name}"`;
        case 'APPOINTMENT_CANCELLED':
            return `Appointment cancelled for business "${data.name}"`;
        default:
            return `Unknown template: ${template}`;
    }
};